import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiMenu, FiX, FiLogOut, FiUser, FiSearch, FiCalendar, FiGrid, FiClock } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { Avatar } from './Components';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const initials = user?.avatar || user?.name?.split(' ').map(n => n[0]).join('') || '?';

  const navLinks = [
    { to: '/dashboard', label: 'Dashboard', icon: <FiGrid size={16} /> },
    ...(user?.role === 'candidate' ? [{ to: '/search', label: 'Find Coaches', icon: <FiSearch size={16} /> }] : []),
    { to: '/bookings', label: 'My Sessions', icon: <FiCalendar size={16} /> },
    ...(user?.role === 'coach' ? [{ to: '/availability', label: 'Availability', icon: <FiClock size={16} /> }] : []),
  ];

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <Link to="/dashboard" className="navbar__brand">
          <span className="navbar__logo">◉</span>
          <span className="navbar__title">CoachConnect</span>
        </Link>

        <div className={`navbar__links ${mobileOpen ? 'navbar__links--open' : ''}`}>
          {navLinks.map(({ to, label, icon }) => (
            <Link
              key={to}
              to={to}
              className={`navbar__link ${location.pathname === to ? 'navbar__link--active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              {icon}
              <span>{label}</span>
            </Link>
          ))}
        </div>

        <div className="navbar__right">
          <Link to="/profile" className="navbar__profile" onClick={() => setMobileOpen(false)}>
            <Avatar initials={initials} size="sm" />
            <div className="navbar__profile-info">
              <span className="navbar__profile-name">{user?.name}</span>
              <span className="navbar__profile-role">{user?.role}</span>
            </div>
          </Link>

          <button className="navbar__logout" onClick={handleLogout} title="Logout">
            <FiLogOut size={16} />
          </button>

          <button className="navbar__mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <FiX size={22} /> : <FiMenu size={22} />}
          </button>
        </div>
      </div>
    </nav>
  );
}
